module.exports = __webpack_public_path__ + "img/riskheadersection.c5f9c360.png";